import { useContext } from "react";
import { ThemeContext } from "../apps/leap/ThemeContext";

const useTheme = () => useContext(ThemeContext);

export default useTheme;
